<template>
  <div class="row">
    <div class="col-12 card" v-if="!postRequest">
      <div class="header-section">
        <h4 class="card-title">Создать новый автомобиль</h4>
        <div class="button-group">
          <router-link to="/">
            <button class="btn-secondary">Отменить</button>
          </router-link>
          <button class="btn-primary" v-on:click="createOrder">
            <span class="icon-Plus"></span>Сохранить
          </button>
        </div>
      </div>

      <div class="form-section">
        <div class="text-field">
          <label class="text-field__label" for="carNumber">Государственный регистрационный номер</label>
          <div class="text-field__icon">
            <input
                class="text-field__input"
                :class="{ 'error': !isCarValid && orderCar }"
                type="text"
                name="carNumber"
                id="carNumber"
                placeholder="А 125 АА 152 или 9933 АА 152"
                v-model="orderCar"
                @input="formatCarNumber"
                maxlength="14"
            >
            <div v-if="!isCarValid && orderCar" class="error-message">
              Неверный формат номера. Пример: А 123 БЦ 78 / А 123 БЦ 178 или 1234 БЦ 78 / 1234 БЦ 178
            </div>
          </div>
        </div>

        <div class="text-field">
          <label class="text-field__label" for="volume">Объём загрузки</label>
          <div class="text-field__icon">
            <input class="text-field__input" type="number" name="volume" id="volume" placeholder="м3" v-model="orderCarVolume">
          </div>
        </div>

        <div class="text-field">
          <label class="text-field__label" for="compaction">Коэффициент уплотнения</label>
          <div class="text-field__icon">
            <input class="text-field__input" type="number" step="0.1" name="compaction" id="compaction" placeholder="Укажите коэффициент в формате 1.1" v-model="orderCarCompaction">
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 card" v-if="postRequest">
      <div class="result-section">
        <h4 class="card-title" v-if="!postError">{{ backendResponse }}</h4>
        <h4 class="card-title" v-else>{{ backendResponse }}</h4>
        <div class="result-buttons">
          <button class="btn-primary" v-on:click="postRequest = false" v-if="postError">Попробовать снова</button>
          <router-link to="/" v-else>
            <button class="btn-primary">Вернуться на главную</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { processInput, isValid } from '@/utils/carNumber';

export default {
  data() {
    return {
      title: "Добавить автомобиль в базу",
      orderCar: '',
      orderCarVolume: '',
      orderCarCompaction: '',
      postError: false,
      postRequest: false,
      isCarValid: true,
      backendResponse: null
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  mounted() {
    document.title = this.title;
  },
  methods: {
    formatCarNumber(event) {
      const { formatted, clean } = processInput(event.target.value);
      this.orderCar = formatted;
      this.isCarValid = isValid(clean);
    },

    getCleanNumber() {
      return this.orderCar.replace(/\s/g, '');
    },

    async createOrder() {
      const clean = this.getCleanNumber();
      this.isCarValid = isValid(clean);
      if (!this.isCarValid) {
        return;
      }

      if (!this.orderCar.trim() || !this.orderCarVolume || !this.orderCarCompaction) {
        this.postRequest = true;
        this.postError = true;
        this.backendResponse = "Заполните все обязательные поля";
        return;
      }

      if (this.orderCarVolume <= 0 || this.orderCarCompaction <= 0) {
        this.postRequest = true;
        this.postError = true;
        this.backendResponse = "Объём и коэффициент должны быть больше 0";
        return;
      }

      const payload = {
        CompanyINN: this.currentUser.company_inn[0],
        CarNumber: this.getCleanNumber().toUpperCase(),
        Measurement: 'м3',
        CarVolume: parseFloat(this.orderCarVolume),
        Compaction: parseFloat(this.orderCarCompaction)
      };

      this.postRequest = true;
      try {
        const response = await axios.post(
            `${this.$store.state.domain}/api/polygon/create_waste_car`,
            payload
        );

        // Убираем кавычки из ответа
        let responseText = '';
        if (typeof response.data === 'object') {
          responseText = response.data.answer || response.data.error || JSON.stringify(response.data);
        } else {
          responseText = response.data;
        }

        // Удаляем кавычки в начале и конце строки
        this.backendResponse = responseText.replace(/^"|"$/g, '');
        this.postError = false;
        console.log("Машина создана:", response.data);

        setTimeout(() => {
          this.$router.push('/');
        }, 2000);

      } catch (err) {
        this.postError = true;
        // Обрабатываем ошибки и убираем кавычки
        let errorText = '';
        if (err.response && err.response.data) {
          if (typeof err.response.data === 'object') {
            errorText = err.response.data.answer || err.response.data.error || "Произошла ошибка";
          } else {
            errorText = err.response.data;
          }
        } else {
          errorText = "Ошибка соединения с сервером";
        }

        // Удаляем кавычки в начале и конце строки
        this.backendResponse = errorText.replace(/^"|"$/g, '');
        console.error("Ошибка при создании автомобиля:", err);
      }
    },
  }
};
</script>

<style scoped>
.error {
  border-color: #ff4444 !important;
}

.error-message {
  color: #ff4444;
  font-size: 12px;
  margin-top: 5px;
}

/* Стили для заголовка и кнопок */
.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 16px;
}

.card-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0;
  flex: 1;
  min-width: 200px;
}

.button-group {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.btn-primary, .btn-secondary {
  min-width: 120px;
  height: 40px;
  padding: 0 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-primary:hover {
  background-color: #0056b3;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background-color: #545b62;
}

/* Стили для формы */
.form-section {
  max-width: 500px;
}

.text-field {
  margin-bottom: 24px;
}

.text-field__label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.text-field__input {
  width: 100%;
  max-width: 400px;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
  transition: border-color 0.2s ease;
}

.text-field__input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.text-field__input.error {
  border-color: #ff4444;
  box-shadow: 0 0 0 2px rgba(255, 68, 68, 0.25);
}

/* Стили для карточки результата */
.result-section {
  text-align: center;
  padding: 40px 20px;
}

.result-buttons {
  margin-top: 24px;
}

/* Адаптивность */
@media (max-width: 768px) {
  .header-section {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .button-group {
    justify-content: stretch;
  }

  .btn-primary, .btn-secondary {
    flex: 1;
    min-width: auto;
  }

  .text-field__input {
    max-width: 100%;
  }

  .form-section {
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .button-group {
    flex-direction: column;
  }

  .btn-primary, .btn-secondary {
    width: 100%;
  }

  .card {
    padding: 16px;
  }

  .header-section {
    margin-bottom: 24px;
  }
}
</style>